export default __webpack_public_path__ + "static/media/Camera.6df1f8d3.svg";